import * as React from "react";
export class EmptyMsg extends React.Component {
    render() {
        return (React.createElement("p", { className: "rj-yourbet__empty-msg" }, this.props.label));
    }
}
//# sourceMappingURL=EmptyMsg.js.map